import { Api } from './api';

export class AchievementsApi {
    private static readonly PATH = '/achievements';

    constructor(private readonly m_api: Api) {}

    public async getAchievements() {
        return this.m_api.get(AchievementsApi.PATH);
    }
}
